import React,{cloneElement} from 'react'
import { useSelector } from 'react-redux';
import { PERMISSIONS } from 'src/constants/roles';


const hasPermission = ({ permissions, scopes }) => {
  const scopesMap = {};
  scopes.forEach((scope) => {
    scopesMap[scope] = true;
  });

  return permissions.some((permission) => scopesMap[permission]);
};


function PermissionsGate({ children,section, scopes = [],RenderError = () => <></>,errorProps = null}) {
const userRole = useSelector(state => state.account.user.role);
const permissions = PERMISSIONS[userRole][section];
const permissionGranted = hasPermission({ permissions, scopes });

  if (!permissionGranted && !errorProps && !RenderError) return <></>

  if (!permissionGranted && !errorProps) return <RenderError />;

  if (!permissionGranted && errorProps)
    return cloneElement(children, { ...errorProps });

  return <>{children}</>;
}

export default PermissionsGate